export interface Agent {
  name: string
  title: string
  phone: string
  image: string
}

export interface Property {
  id: string
  image: string
  gallery: string[]
  price: string
  address: string
  city: string
  beds: number
  baths: number
  sqft: string
  lotSize: string
  yearBuilt: number
  isNew?: boolean
  description: string
  amenities: string[]
  agent: Agent
}

const defaultAgent: Agent = {
  name: 'Eleanor Vance',
  title: 'Senior Private Advisor',
  phone: '+1 (310) 555-0198',
  image:
    'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
}

const defaultAmenities = [
  'Smart Home Technology',
  "Chef's Kitchen",
  'Wine Cellar',
  'Home Theater',
  'Infinity Pool',
  'Spa & Wellness Center',
  'Motor Court',
  'Panoramic Views',
]

export const PROPERTIES: Property[] = [
  {
    id: '1',
    image:
      'https://images.unsplash.com/photo-1613977257363-707ba9348227?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1613977257363-707ba9348227?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80',
      'https://images.unsplash.com/photo-1600566753376-12c8ab7fb75b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80',
      'https://images.unsplash.com/photo-1600585154526-990dced4db0d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80',
    ],
    price: '$12,500,000',
    address: '1423 Oriole Dr',
    city: 'Los Angeles, CA',
    beds: 5,
    baths: 7,
    sqft: '8,200',
    lotSize: '0.8 Acres',
    yearBuilt: 2022,
    isNew: true,
    description:
      'A masterful architectural triumph situated in the highly coveted Bird Streets. This newly constructed estate offers unparalleled jetliner views from Downtown to the ocean. Featuring seamless indoor-outdoor living, the property boasts a zero-edge infinity pool, a state-of-the-art screening room, and a wellness center complete with a sauna and massage room. The primary suite is a sanctuary of its own with dual spa-like baths and bespoke dressing rooms.',
    amenities: defaultAmenities,
    agent: defaultAgent,
  },
  {
    id: '2',
    image:
      'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80',
      'https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80',
      'https://images.unsplash.com/photo-1600607687644-c7171b42498b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80',
    ],
    price: '$8,950,000',
    address: '845 Sea View Ave',
    city: 'Montecito, CA',
    beds: 4,
    baths: 5,
    sqft: '5,400',
    lotSize: '1.2 Acres',
    yearBuilt: 2018,
    description:
      'An exquisite Mediterranean-inspired villa nestled in the heart of Montecito. Surrounded by lush, mature landscaping, this private compound offers a serene escape. The residence features soaring beamed ceilings, custom ironwork, and imported stone floors. The gourmet kitchen opens to a sun-drenched loggia, perfect for al fresco dining. The sprawling grounds include a resort-style pool, a guest casita, and manicured gardens.',
    amenities: [
      'Guest House',
      'Ocean Views',
      'Gated Entry',
      'Outdoor Kitchen',
      'Library',
      'Wine Cellar',
    ],
    agent: { ...defaultAgent, name: 'Marcus Sterling' },
  },
  {
    id: '3',
    image:
      'https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80',
      'https://images.unsplash.com/photo-1600566752355-35792bedcfea?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80',
      'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80',
    ],
    price: '$24,000,000',
    address: '111 W 57th St, PH 72',
    city: 'New York, NY',
    beds: 3,
    baths: 4,
    sqft: '4,100',
    lotSize: 'N/A',
    yearBuilt: 2021,
    description:
      'A crown jewel in the Manhattan skyline. This full-floor penthouse offers breathtaking, unobstructed 360-degree views of Central Park, the city skyline, and beyond. Designed with meticulous attention to detail, the residence features custom millwork, floor-to-ceiling windows, and a grand salon perfect for entertaining. Residents enjoy white-glove service, a private dining room, and an 82-foot lap pool.',
    amenities: [
      '24/7 Concierge',
      'Private Elevator Landing',
      'Fitness Center',
      'Indoor Pool',
      'Central Park Views',
    ],
    agent: { ...defaultAgent, name: 'Victoria Chen' },
  },
  {
    id: '4',
    image:
      'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80',
      'https://images.unsplash.com/photo-1600607687931-cebf14cdff12?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80',
      'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80',
    ],
    price: '$15,750,000',
    address: '3200 Star Island Dr',
    city: 'Miami Beach, FL',
    beds: 6,
    baths: 8,
    sqft: '10,500',
    lotSize: '0.9 Acres',
    yearBuilt: 2020,
    description:
      'Modern waterfront luxury on the exclusive Star Island. This striking contemporary estate features over 100 feet of prime water frontage with a private dock. The open-concept design is highlighted by walls of glass that disappear, blending the lavish interiors with the tropical outdoors. Features include a double-height living room, a custom Italian kitchen, and a spectacular rooftop terrace.',
    amenities: [
      'Private Dock',
      'Waterfront',
      'Rooftop Terrace',
      'Home Automation',
      'Elevator',
      'Staff Quarters',
    ],
    agent: defaultAgent,
  },
  {
    id: '5',
    image:
      'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80',
      'https://images.unsplash.com/photo-1600573472550-8090b5e0745e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80',
      'https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80',
    ],
    price: '$9,200,000',
    address: '4500 E Camelback Rd',
    city: 'Paradise Valley, AZ',
    beds: 5,
    baths: 6,
    sqft: '7,800',
    lotSize: '2.1 Acres',
    yearBuilt: 2019,
    description:
      'A desert masterpiece offering ultimate privacy and stunning Camelback Mountain views. This architectural gem utilizes natural materials, including rammed earth and native stone, to harmonize with its surroundings. The resort-style backyard features a multi-level pool, fire features, and extensive covered patios. The interior boasts a massive great room, a glass-enclosed wine room, and a luxurious primary wing.',
    amenities: [
      'Mountain Views',
      'Multi-level Pool',
      'Wine Room',
      'Outdoor Kitchen',
      'Guest Casita',
      'Desert Landscaping',
    ],
    agent: { ...defaultAgent, name: 'Marcus Sterling' },
  },
  {
    id: '6',
    image:
      'https://images.unsplash.com/photo-1600573472550-8090b5e0745e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80',
    gallery: [
      'https://images.unsplash.com/photo-1600573472550-8090b5e0745e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80',
      'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80',
      'https://images.unsplash.com/photo-1600607687931-cebf14cdff12?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80',
    ],
    price: '$18,500,000',
    address: '2500 Red Mountain Rd',
    city: 'Aspen, CO',
    beds: 6,
    baths: 7,
    sqft: '9,100',
    lotSize: '3.5 Acres',
    yearBuilt: 2023,
    isNew: true,
    description:
      'The pinnacle of alpine luxury. Located on prestigious Red Mountain, this newly completed estate offers sweeping views of Aspen Mountain and the Roaring Fork Valley. The design seamlessly blends contemporary aesthetics with warm mountain textures. Features include a ski room, an indoor-outdoor heated pool, a state-of-the-art gym, and expansive decks for entertaining in any season.',
    amenities: [
      'Ski Room',
      'Heated Pool',
      'Home Gym',
      'Mountain Views',
      'Heated Driveway',
      'Media Room',
    ],
    agent: { ...defaultAgent, name: 'Victoria Chen' },
  },
]
